const dictionary = {
  layout: {
    siteHeader: {
      'menu-item-multipass': 'Multipass',
      'menu-item-account': 'Min Konto',
      'menu-item-support': 'Support'
    },

    sidebar: { 'button-toggler-ariaLabel': 'Skift sidebjælken' }
  },

  pages: {
    error: {
      401: {
        'document-title': 'Uberettiget',
        'document-desc': '',
        'main-heading': '401 - Uberettiget',
        'page-content': 'Du har ikke adgang til denne side uden at logge ind.'
      },

      404: {
        'document-title': 'Siden blev ikke fundet',
        'document-desc': '',
        'main-heading': '404 - Siden blev ikke fundet',
        'page-content': 'Den side du ledte efter, findes ikke.'
      },

      500: {
        'document-title': 'Der er sket en fejl',
        'document-desc': '',
        'main-heading': 'Noget gik galt',
        'page-content': 'Prøv igen senere.'
      }
    }
  },

  elements: {
    editableText: { 'message-success': '{inputLabel} opdateret med succes' },

    editorControl: {
      'button-edit': 'Rediger',
      'button-edit-ariaLabel': 'Rediger {ariaEditorName}',
      'button-closer': 'Annuller',
      'button-closer-ariaLabel': 'Annuller ændringer',
      'button-submit': 'Gem',
      'button-submit-ariaLabel': 'Gem ændringer'
    },

    customDayPicker: {
      'controller-button-month-next-ariaLabel': 'Næste måned',
      'controller-button-month-prev-ariaLabel': 'Forrige månedh',
      'navbar-button-month-prev-ariaLabel': 'Gå til forrige måned ({monthNamePrev})',
      'navbar-button-month-next-ariaLabel': 'Gå til næste måned ({monthNameNext})',
      'navbar-button-year-prev-ariaLabel': 'Gå til forrige år ({yearPrev})',
      'navbar-button-year-next-ariaLabel': 'Gå til næste år ({yearNext})'
    },

    customInput: {
      'passwordMeter-ariaLabel': 'Dit kodeord er {strength}',
      'passwordMeter-strength-min': 'Uacceptabelt',
      'passwordMeter-strength-low': 'Meget svag',
      'passwordMeter-strength-mid': 'Svag',
      'passwordMeter-strength-high': 'God',
      'passwordMeter-strength-max': 'Stærk',
      'input-date-button-dropdown-ariaLabel': 'Skift rullemenuen for datovalg'
    },

    menu: { 'button-toggler-ariaLabel': 'Skift menuen' },

    loader: { 'text-loading': 'Indlæser' },

    hugeStatusIndicator: {
      'text-pending': 'Verserende',
      'text-success': 'Success',
      'text-error': 'Fejl'
    }
  },

  lists: {
    systemMessages: {
      'list-ariaLabel': 'Systemmeddelelser',
      'list-item-ariaLabel': 'Systemmeddelelse',
      'list-item-button-dismiss-ariaLabel': 'Afvis denne meddelelse',
      'text-ariaLabel-success': 'Succes: {message}',
      'text-ariaLabel-info': 'Information: {message}',
      'text-ariaLabel-warning': 'Advarsel: {message}',
      'text-ariaLabel-error': 'Der er sket en fejl: {message}'
    }
  },

  general: {
    messages: {
      'error-general': 'Noget gik galt',
      'error-input-empty': 'Feltet {fieldName} er påkrævet',
      'error-input-format': 'Formatet for feltet {fieldName} er ugyldigt',
      'error-input-email-format': 'Det angivne e-mail-format er ugyldigt',
      'error-input-password-weak': 'Denne adgangskode er for svag',
      'error-input-unmatch':
        'Indtastningsværdien af feltet {thisFieldName} stemmer ikke overens med {comparedFieldName}s',
      'error-input-long': 'Denne værdi er for lang - kun {maxLength} tegn er tilladt',
      'prompt-leavingDirtyForm':
        'Du har allerede udfyldt nogle af de input, hvis data vil gå tabt, hvis du forlader formularen. '
        + 'Er du sikker på, at du vil fortsætte?'
    },

    dates: {
      'month-1': 'Januar',
      'month-2': 'Februar',
      'month-3': 'Marts',
      'month-4': 'April',
      'month-5': 'Maj',
      'month-6': 'Juni',
      'month-7': 'Juli',
      'month-8': 'August',
      'month-9': 'September',
      'month-10': 'Oktober',
      'month-11': 'November',
      'month-12': 'December',
      'day-1': 'Mandag',
      'day-2': 'Tirsdag',
      'day-3': 'Onsdag',
      'day-4': 'Torsdag',
      'day-5': 'Fredag',
      'day-6': 'Lørdag',
      'day-7': 'Søndag'
    },

    units: {
      'piece-short': 'stk.'
    }
  }
};

export default dictionary;